import { render } from "./ArrowRight.vue?vue&type=template&id=22c4fcd4"
const script = {}

import exportComponent from "/opt/sources/madarion/mdnw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__